module.exports = __webpack_public_path__ + "img/895f8cf3-what-happens-if-you-consumed-expired-tablets-or-syrups-640x480.5ed52f16.jpg";